import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { Trans, t } from '@lingui/macro';
import { I18n } from '@lingui/react';
import styles from './ResetGoBizPassword.css';
import { resetGoBizPassword } from '../../state/resetGoBizPassword/actions';

class ResetGoBizPassword extends React.Component {
  state = {
    email: '',
  };

  handleEmailChange = e => {
    this.setState({
      email: e.target.value,
    });
  };

  handleSubmit = e => {
    e.preventDefault();

    const { onSubmit } = this.props;
    const { email } = this.state;
    onSubmit(email);
  };

  render() {
    const { email } = this.state;

    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.title}>
            <Trans>Reset Password</Trans>
          </div>

          <div className={styles.instruction}>
            <Trans>
              Enter your GoBiz email to receive the reset instruction
            </Trans>
          </div>
        </div>

        <form onSubmit={this.handleSubmit}>
          <div className="form-group">
            <I18n>
              {({ i18n }) => (
                <input
                  type="text"
                  name="email"
                  className="form-control"
                  placeholder={i18n._(t`GoBiz Email`)}
                  autoCapitalize="off"
                  autoCorrect="off"
                  maxLength="255"
                  spellCheck="false"
                  autoFocus
                  value={email}
                  onChange={this.handleEmailChange}
                />
              )}
            </I18n>
          </div>

          <div className="form-group">
            <button type="submit" className="btn btn-primary btn-block">
              <Trans>Reset Password</Trans>
            </button>
          </div>
        </form>

        <div className={styles.footer}>
          <Link to="/login">
            <Trans>Back to Sign In</Trans>
          </Link>
        </div>
      </div>
    );
  }
}

ResetGoBizPassword.defaultProps = {
  onSubmit: () => {},
};

const mapDispatchToProps = {
  onSubmit: resetGoBizPassword,
};

export default connect(
  null,
  mapDispatchToProps
)(ResetGoBizPassword);
